import PropTypes from "prop-types"
import { get } from "lodash"
import BetaInstrument from "../betaInstrument"
import UnifiedSearch from "modules/unified-search"
import { RECENT_INSTRUMENT_SEARCH_TYPES } from "resources/instruments"

const allowedTypes = ["security", "portfolio", "index", "swap", "benchmark"]

function filterEquitySearchResults(value) {
  return get(value, "assetClass") !== "equity" || get(value, "assetSubclass") === "etf"
}

function disableResult(item) {
  return get(item, "assetClass") === "equity" && get(item, "assetSubclass") !== "etf"
}

function BetaInstrumentSelector({ account, modelId, betaInstrument, handleInstrumentSelected }) {
  const itemsActions = {
    security: {
      noDispatch: true,
      mainAction: selectedItem => () => {
        const { mic, exchange } = selectedItem
        handleInstrumentSelected({
          ...selectedItem,
          ...(!mic ? { mic: exchange } : {}),
        })
      },
    },
    portfolio: {
      noDispatch: true,
      mainAction: selectedItem => () => {
        handleInstrumentSelected(selectedItem)
      },
    },
    benchmark: {
      noDispatch: true,
      mainAction: selectedItem => () => {
        handleInstrumentSelected(selectedItem)
      },
    },
    index: {
      noDispatch: true,
      mainAction: selectedItem => () => {
        handleInstrumentSelected(selectedItem)
      },
    },
  }

  if (betaInstrument) {
    return <BetaInstrument betaInstrument={betaInstrument} clear={handleInstrumentSelected} />
  } else {
    return <UnifiedSearch {
      ...{
        account,
        modelId,
        isDisabled: !modelId,
        disableResult,
        searchType: RECENT_INSTRUMENT_SEARCH_TYPES.BASE, // Beta instruments and base instruments are similar in use
        filterEquities: filterEquitySearchResults,
        placeholder: "Search for Beta Instrument...",
        allowedTypes,
        itemsActions,
      }
    }
    />
  }
}

BetaInstrumentSelector.propTypes = {
  account: PropTypes.string.isRequired,
  modelId: PropTypes.string,
  betaInstrument: PropTypes.shape({
    id: PropTypes.string,
    ticker: PropTypes.string,
    mic: PropTypes.string,
    type: PropTypes.oneOf(["portfolio", "benchmark", "index", "security"]),
    assetClass: PropTypes.oneOf(["swap", "equity"]),
    assetSubclass: PropTypes.oneOf(["etf"]),
    description: PropTypes.string,
    isUnavailable: PropTypes.bool,
    isUnmodeled: PropTypes.bool,
    isPermissionDenied: PropTypes.bool,
  }),
  handleInstrumentSelected: PropTypes.func.isRequired,
}

export default BetaInstrumentSelector
